import React from 'react';
import { number } from 'prop-types';
import { LoadingPlaceholder, TextRow, TextBlock, RectShape } from '@thd-olt-component-react/loading-placeholder';
import './buyboxLoader.scss';

const BuyboxLoader = ({ tilesCount = 3 }) => {
  const cardFoot = { height: '1rem' };
  const cardHead = { height: '2rem' };
  const tileArray = [];
  for (let i = 0; i < tilesCount; i += 1) {
    tileArray.push(
      <div className="card card-container card-unselected card-disabled" key={i}>
        <div className="loader-container">
          <div className="card-head">
            <LoadingPlaceholder
              type="textRow"
              color="#E0E0E0"
              style={cardHead}
              showLoadingAnimation
              ready={false}
            >
              Buybox Loader
            </LoadingPlaceholder>
          </div>
          <LoadingPlaceholder
            type="textRow"
            color="#E0E0E0"
            style={cardFoot}
            showLoadingAnimation
            ready={false}
          >
            Buybox Loader
          </LoadingPlaceholder>
          <LoadingPlaceholder
            type="textRow"
            color="#E0E0E0"
            style={cardFoot}
            showLoadingAnimation
            ready={false}
          >
            Buybox Loader
          </LoadingPlaceholder>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="buybox__loader--title">How to Get It</div>
      <div className="buybox__loader-wrapper card-deck">
        {tileArray}
      </div>
    </>
  );
};

BuyboxLoader.propTypes = {
  tilesCount: number
};

BuyboxLoader.defaultProps = {
  tilesCount: 3
};

export { BuyboxLoader };
